export default {
    lang:'en',
    translations: {
        lang: '',
        data: ''
    }
}